<template>
  <div class="others-information">
    <!-- EXTRA CURRICULAR ACTIVITIES Section -->
    <v-card variant="outlined" class="pa-2 mb-2">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-account-star</v-icon>
        EXTRA CURRICULAR ACTIVITIES
      </v-card-title>
      <v-form ref="extraCurricularForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-1">
            <v-text-field
              v-model="otherInfo.extra_curricular_activities"
              label="Extra Curricular Activities"
              variant="outlined"
              density="compact"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pa-1">
            <v-textarea
              v-model="otherInfo.extra_curricular_remarks"
              label="Remarks"
              variant="outlined"
              density="compact"
              rows="3"
              auto-grow
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- AREA OF SPECIALIZATION Section -->
    <v-card variant="outlined" class="pa-2 mb-2">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-account-tie</v-icon>
        AREA OF SPECIALIZATION
      </v-card-title>
      <v-form ref="specializationForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-1">
            <v-text-field
              v-model="otherInfo.area_of_specialization"
              label="Area of Specialization"
              variant="outlined"
              density="compact"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pa-1">
            <v-textarea
              v-model="otherInfo.specialization_remarks"
              label="Remarks"
              variant="outlined"
              density="compact"
              rows="3"
              auto-grow
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- LANGUAGE PROFICIENCY Section -->
    <v-card variant="outlined" class="pa-2">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-translate</v-icon>
        LANGUAGE PROFICIENCY
      </v-card-title>
      
      <v-form ref="languageForm" class="pa-1">
        <!-- Language Proficiency Table -->
        <v-table density="compact" class="mb-3">
          <thead>
            <tr class="bg-grey-lighten-4">
              <th class="text-left pa-2 text-caption font-weight-bold">Language</th>
              <th class="text-left pa-2 text-caption font-weight-bold">Writing</th>
              <th class="text-left pa-2 text-caption font-weight-bold">Reading</th>
              <th class="text-left pa-2 text-caption font-weight-bold">Speaking</th>
              <th class="text-left pa-2 text-caption font-weight-bold">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(language, index) in languageProficiencies" :key="index" class="border-b">
              <td class="pa-1">
                <v-text-field
                  v-model="language.language"
                  variant="outlined"
                  density="compact"
                  hide-details
                  placeholder="Enter language"
                  class="language-input"
                ></v-text-field>
              </td>
              <td class="pa-1">
                <v-select
                  v-model="language.writing"
                  :items="proficiencyLevels"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  density="compact"
                  hide-details
                  placeholder="Select"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
              </td>
              <td class="pa-1">
                <v-select
                  v-model="language.reading"
                  :items="proficiencyLevels"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  density="compact"
                  hide-details
                  placeholder="Select"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
              </td>
              <td class="pa-1">
                <v-select
                  v-model="language.speaking"
                  :items="proficiencyLevels"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  density="compact"
                  hide-details
                  placeholder="Select"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
              </td>
              <td class="pa-1">
                <v-btn
                  v-if="languageProficiencies.length > 1"
                  color="error"
                  variant="text"
                  size="small"
                  icon="mdi-delete"
                  @click="removeLanguage(index)"
                  class="delete-btn"
                ></v-btn>
                <span v-else class="text-caption text-grey">Required</span>
              </td>
            </tr>
          </tbody>
        </v-table>

        <!-- Add More Button -->
        <v-row class="ma-0 mb-2">
          <v-col cols="12" class="pa-1">
            <v-btn
              color="orange"
              variant="outlined"
              size="small"
              @click="addLanguage"
              class="add-more-btn"
            >
              <v-icon class="me-1" size="small">mdi-plus</v-icon>
              ADD MORE
            </v-btn>
          </v-col>
        </v-row>

        <!-- Navigation -->
        <v-row class="ma-0">
          <v-col cols="12" class="pa-1 d-flex align-center justify-center">
            <v-btn
              icon="mdi-chevron-left"
              variant="text"
              size="small"
              @click="previousLanguage"
              :disabled="currentLanguageIndex === 0"
              class="nav-btn"
            ></v-btn>
            <span class="mx-2 text-caption text-grey-darken-1">
              Page {{ currentLanguageIndex + 1 }} of {{ totalLanguagePages }}
            </span>
            <v-btn
              icon="mdi-chevron-right"
              variant="text"
              size="small"
              @click="nextLanguage"
              :disabled="currentLanguageIndex >= totalLanguagePages - 1"
              class="nav-btn"
            ></v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { toast } from 'vue3-toastify'

// Props
const props = defineProps({
  otherInfo: {
    type: Object,
    required: true
  },
  employeeId: {
    type: [String, Number],
    required: true
  }
})

// Emits
const emit = defineEmits(['update:otherInfo'])

// Store
const store = useStore()

// Local refs
const extraCurricularForm = ref(null)
const specializationForm = ref(null)
const languageForm = ref(null)
const currentLanguageIndex = ref(0)
const itemsPerPage = 5
const dataLoaded = ref(false)

// Language proficiency levels
const proficiencyLevels = [
  { text: 'Beginner', value: 'beginner' },
  { text: 'Elementary', value: 'elementary' },
  { text: 'Intermediate', value: 'intermediate' },
  { text: 'Upper Intermediate', value: 'upper_intermediate' },
  { text: 'Advanced', value: 'advanced' },
  { text: 'Fluent', value: 'fluent' },
  { text: 'Native', value: 'native' }
]

// Computed properties
const languageProficiencies = computed({
  get: () => {
    const start = currentLanguageIndex.value * itemsPerPage
    const end = start + itemsPerPage
    return props.otherInfo.language_proficiencies?.slice(start, end) || []
  },
  set: (value) => {
    const start = currentLanguageIndex.value * itemsPerPage
    const updated = [...(props.otherInfo.language_proficiencies || [])]
    value.forEach((item, index) => {
      updated[start + index] = item
    })
    emit('update:otherInfo', {
      ...props.otherInfo,
      language_proficiencies: updated
    })
  }
})

const totalLanguagePages = computed(() => {
  const total = props.otherInfo.language_proficiencies?.length || 0
  return Math.ceil(total / itemsPerPage) || 1
})

// Methods
const addLanguage = () => {
  const newLanguage = {
    language: '',
    writing: '',
    reading: '',
    speaking: ''
  }
  
  const updated = [...(props.otherInfo.language_proficiencies || []), newLanguage]
  emit('update:otherInfo', {
    ...props.otherInfo,
    language_proficiencies: updated
  })
}

const removeLanguage = (index) => {
  const globalIndex = currentLanguageIndex.value * itemsPerPage + index
  const updated = [...(props.otherInfo.language_proficiencies || [])]
  updated.splice(globalIndex, 1)
  emit('update:otherInfo', {
    ...props.otherInfo,
    language_proficiencies: updated
  })
}

const nextLanguage = () => {
  if (currentLanguageIndex.value < totalLanguagePages.value - 1) {
    currentLanguageIndex.value++
  }
}

const previousLanguage = () => {
  if (currentLanguageIndex.value > 0) {
    currentLanguageIndex.value--
  }
}


// Load other information data
const loadOtherInfo = async () => {
  if (!props.employeeId || dataLoaded.value) return
  
  try {
    const response = await store.dispatch('otherInfo/getOtherInfoByEmployee', props.employeeId)
    
    // Store resolves with full Axios response; API body is in response.data
    const apiResponse = response?.data
    if (apiResponse?.success && apiResponse?.data) {
      // Update the otherInfo with loaded data
      const loadedData = apiResponse.data
      emit('update:otherInfo', {
        ...props.otherInfo,
        ...loadedData,
        // Ensure language_proficiencies is an array
        language_proficiencies: loadedData.language_proficiencies || []
      })
      dataLoaded.value = true
    } else {
      // Initialize with empty language entry if no data exists
      if (!props.otherInfo.language_proficiencies || props.otherInfo.language_proficiencies.length === 0) {
        addLanguage()
      }
      dataLoaded.value = true
    }
  } catch (error) {
    console.error('Error loading other info:', error)
    // Initialize with empty language entry on error
    if (!props.otherInfo.language_proficiencies || props.otherInfo.language_proficiencies.length === 0) {
      addLanguage()
    }
    dataLoaded.value = true
  }
}

// Save other information data
const saveOtherInfo = async () => {
  if (!props.employeeId) {
    throw new Error('Employee ID is required')
  }

  try {
    const response = await store.dispatch('otherInfo/saveEmployeeOtherInfo', {
      employeeId: props.employeeId,
      otherInfoData: props.otherInfo || {}
    })

    // Store resolves with full Axios response; API body is in response.data
    const data = response?.data
    if (data?.success) {
      toast.success('Other information saved successfully')
      if (data.data) {
        emit('update:otherInfo', {
          ...props.otherInfo,
          ...data.data
        })
      }
    } else {
      throw new Error(data?.message || 'Failed to save other information')
    }
  } catch (error) {
    console.error('Error saving other info:', error)
    throw error
  }
}

// Watch for changes and emit updates
watch(() => props.otherInfo, (newValue) => {
  emit('update:otherInfo', newValue)
}, { deep: true })

// Watch for employee ID changes
watch(() => props.employeeId, (newId) => {
  if (newId && !dataLoaded.value) {
    loadOtherInfo()
  }
}, { immediate: true })

// Initialize with one empty language entry if none exist
onMounted(() => {
  // Data loading handled by watch with immediate: true
  // if (props.employeeId && !dataLoaded.value) {
  //   loadOtherInfo()
  // } else 
  if (!props.otherInfo.language_proficiencies || props.otherInfo.language_proficiencies.length === 0) {
    addLanguage()
  }
})

// Expose form validation methods and save function
defineExpose({
  validate: async () => {
    const extraCurricularValid = await extraCurricularForm.value?.validate()
    const specializationValid = await specializationForm.value?.validate()
    const languageValid = await languageForm.value?.validate()
    return extraCurricularValid?.valid && specializationValid?.valid && languageValid?.valid
  },
  saveOtherInfo,
  loadOtherInfo,
})
</script>

<style scoped>
/* Language Proficiency Table Styling */
.language-input {
  min-width: 120px;
}

.add-more-btn {
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.delete-btn {
  min-width: 32px;
  height: 32px;
}

.nav-btn {
  min-width: 32px;
  height: 32px;
}

/* Table styling improvements */
.v-table {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.v-table thead th {
  background-color: #f5f5f5 !important;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.v-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
}

.v-table tbody tr:hover {
  background-color: #fafafa;
}

.v-table tbody tr:last-child {
  border-bottom: none;
}

/* Form field styling consistency */
.v-text-field,
.v-select {
  font-size: 0.875rem;
}

.v-text-field .v-field__input,
.v-select .v-field__input {
  min-height: 36px;
  padding: 8px 12px;
}

/* Button styling consistency */
.v-btn {
  font-weight: 500;
  letter-spacing: 0.25px;
}

/* Card styling */
.v-card {
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.v-card-title {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
